/**
 * @Author: Zero
 * @Date: 2024-10-23 02:47:31
 * @Explain: 过滤级联选择列表
 */

import { intlGet } from '@/locales';
import { useMemo, useCallback } from 'react';
import { Checkbox, List } from 'tdesign-react';
import classNames from 'classnames';
// type
import {
  CascaderCommonOptionsType,
  CommonOptionsType,
} from '@/definition/common/data.d';
import { CascaderOptionListProps } from '../data.d';
// utils
import { cascaderInterval, defaultListMaxHeight } from '../const';
import {
  areArraysContentEqual,
  getAllPathsFromRoot,
} from '@/utils/common/dataJudgment';

type PropsType = {
  /** 列表宽度 */
  listWidth?: number | string;
} & CascaderOptionListProps;
const FilterList = (props: PropsType) => {
  const {
    multiple,
    options,
    value,
    displayTextKey,
    emptyText = intlGet('COMMON.NO.DATA'),
    listWidth,
    listMaxHeight = defaultListMaxHeight,
    onChange,
  } = props;

  // 将树形结构数据处理为从根到分支顶端链路各自处理为各自一组数据
  const newOptions = useMemo(() => {
    return getAllPathsFromRoot({ tree: options }) || [];
  }, [options]);

  const onText = (item: any) => intlGet(item.labelKey) || item.label || '';

  /** 重组参数 */
  const getItem = (item: CommonOptionsType) => {
    const text: any = onText(item);
    const tips: any = intlGet(item.tipsKey) || item.tips || text;
    const textRender =
      (displayTextKey && (item as any)[displayTextKey]) || text;

    return {
      text,
      tips,
      textRender,
    };
  };

  // 手动更新选中状态
  // 2.手动切换当前选框勾选状态
  // 2.1 手动选中 - 将当前链路下ID结果 合并 到选中信息集合value中
  // 2.3 手动取消选中 - 将当前链路下ID结果 从选中信息集合value中 剔除
  const handleChange = useCallback(
    ({ allLinkId, status }: any) => {
      // 选中
      if (status) {
        onChange?.([...value, allLinkId], {});
      }
      // 取消选中
      if (!status) {
        let delIndex = value.findIndex((v: any[]) =>
          areArraysContentEqual({
            arr1: v,
            arr2: allLinkId,
          }),
        );
        if (delIndex !== -1) {
          let newValue = value.filter(
            (h: any, hindex: number) => hindex !== delIndex,
          );
          onChange?.(newValue, {});
        }
      }
    },
    [value, newOptions, onChange],
  );

  // 查找当前展示项信息是否携带禁用
  const findListItemDisable = (listItem: CascaderCommonOptionsType[]) => {
    for (let i = 0; i < listItem?.length; i++) {
      const item = listItem[i];
      if (item?.disabled) {
        return true;
      }
    }
    return false;
  };
  return (
    <>
      {multiple ? (
        <List
          className="td-scroll-list-filter"
          style={{ width: listWidth, maxHeight: listMaxHeight }}
        >
          {newOptions.map((item) => {
            let textStr: string = '';
            let textRenderArr: any[] = [];
            // 当前链路下ID信息
            let allLinkId: any[] = [];
            item.map((i: any, index: number) => {
              allLinkId.push(i.value);
              let { tips, textRender } = getItem(i);
              let text = tips;
              if (index !== item.length - 1) {
                text = text + cascaderInterval;
                textRender = (
                  <span>
                    {textRender} {cascaderInterval}
                  </span>
                );
              }
              textStr += text;
              textRenderArr.push(textRender);
            });
            const commonProps = {
              key: item.value,
              title: textStr,
            };
            // 1.查找选中信息中是否存在当前链路ID信息
            // 1.1 查找到 - 选框为选中状态
            // 1.2 未查到 - 选框为非选中状态
            let isChecked = value.some((v: any[]) =>
              areArraysContentEqual({ arr1: v, arr2: allLinkId }),
            );
            // 当前项是否禁用
            const disabled: boolean = findListItemDisable(item);
            return (
              <li
                className={classNames('t-list-item', {
                  'is-disabled': disabled,
                })}
                {...commonProps}
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  handleChange({
                    allLinkId,
                    status: !isChecked,
                  });
                }}
              >
                <div className="t-list-item-main">
                  <Checkbox checked={isChecked} disabled={disabled} />
                  <div className="t-list-item-content">{textRenderArr}</div>
                </div>
              </li>
            );
          })}
        </List>
      ) : (
        '单选级联 - 暂未开发'
      )}
    </>
  );
};

export default FilterList;
